import { useState, useEffect } from 'react'
import RemoveUsers from './components/RemoveUser'
import { BreadCrumbs } from '../company/components/Breadcrumbs'

function UserManagementWrapper({ accountId = '' }) {
  const [selectedIndex, setSelectedIndex] = useState<number>(0)

  const isAccountAdmin = sessionStorage.getItem('isAccountAdmin') === 'true' ? true : false

  const userManagementMenus = [
    ...(isAccountAdmin
      ? [
          {
            title: 'Manage Users',
            subtitle: 'Remove Users from Investor',
            icon: '/media/icons/duotune/general/person-fill-gear.svg',
            isSvg: true,
          },
        ]
      : []),
  ]

  useEffect(() => {
    if (!isAccountAdmin && selectedIndex >= userManagementMenus.length) {
      setSelectedIndex(0)
    }
  }, [isAccountAdmin, selectedIndex, userManagementMenus.length])

  return (
    <div>
      <div className='row'>
        <BreadCrumbs label={'User Management'} isActionItems={false} className='mt-2' />
      </div>
      <div className='row mb-9 gx-4'>
        {selectedIndex === 0 && isAccountAdmin && <RemoveUsers accountId={accountId} />}
      </div>
    </div>
  )
}

export default UserManagementWrapper
